import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaCoins } from 'react-icons/fa';
import { tipsAPI } from '../../utils/api';
import { toast } from 'sonner';

const TIP_PRESETS = [10, 50, 100, 500];

const TipButton = ({ recipientId, targetType = 'post', targetId, currentUserId }) => {
  const [showPicker, setShowPicker] = useState(false);
  const [sending, setSending] = useState(false);

  if (recipientId === currentUserId) return null;

  const handleTip = async (amount) => {
    setSending(true);
    try {
      const res = await tipsAPI.send(recipientId, amount, targetType, targetId);
      toast.success(res.data.message);
      setShowPicker(false);
    } catch (err) {
      const msg = err.response?.data?.detail || 'Failed to send tip';
      if (msg.includes('Insufficient')) {
        toast.error('Not enough PointPhoria! Visit your Wallet to buy more.');
      } else {
        toast.error(msg);
      }
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="relative">
      <button
        onClick={() => setShowPicker(v => !v)}
        data-testid={`tip-btn-${targetId}`}
        className="flex items-center space-x-1.5 px-2 py-1.5 rounded-full text-amber-500 hover:text-amber-600 hover:bg-amber-50 transition-all"
        title="Tip PointPhoria"
      >
        <FaCoins size={14} />
      </button>

      <AnimatePresence>
        {showPicker && (
          <motion.div
            initial={{ opacity: 0, y: 8, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 8, scale: 0.95 }}
            className="absolute bottom-full right-0 mb-2 bg-white border border-gray-200 rounded-2xl shadow-xl p-3 z-30 min-w-[180px]"
            data-testid="tip-picker"
          >
            <p className="text-xs font-semibold text-gray-500 text-center mb-2 font-arthaus">Send PointPhoria</p>
            <div className="grid grid-cols-2 gap-1.5">
              {TIP_PRESETS.map(amount => (
                <button
                  key={amount}
                  onClick={() => handleTip(amount)}
                  disabled={sending}
                  data-testid={`tip-amount-${amount}`}
                  className="flex items-center justify-center gap-1 py-2 rounded-xl text-sm font-semibold bg-amber-50 text-amber-600 hover:bg-amber-100 transition-all disabled:opacity-50"
                >
                  <FaCoins size={10} />
                  <span>{amount}</span>
                </button>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default TipButton;
